export interface AmortOverrideType {
  name: amortOverrideTypeEnum
}

export enum amortOverrideTypeEnum {
  OTHER = 'OTHER',
  OBEY_ACCOUNT_SECURITY = 'OBEY_ACCOUNT_SECURITY',
  FORCE_LEGACY = 'FORCE_LEGACY',
  FORCE_STRAIGHTLINE = 'FORCE_STRAIGHTLINE',
  NO_AMORT = 'NO_AMORT',
  FORCE_NO_PREPAYMENT = 'FORCE_NO_PREPAYMENT',
  NO_AMORT_ERROR = 'NO_AMORT_ERROR',
  FORCE_CONSTANT_YIELD = 'FORCE_CONSTANT_YIELD',
}

export const amortOverrideTypesVal: AmortOverrideType[] = [
  { name: amortOverrideTypeEnum.OTHER },
  { name: amortOverrideTypeEnum.OBEY_ACCOUNT_SECURITY },
  { name: amortOverrideTypeEnum.FORCE_LEGACY },
  { name: amortOverrideTypeEnum.FORCE_STRAIGHTLINE },
  { name: amortOverrideTypeEnum.NO_AMORT },
  { name: amortOverrideTypeEnum.FORCE_NO_PREPAYMENT },
  { name: amortOverrideTypeEnum.NO_AMORT_ERROR },
  { name: amortOverrideTypeEnum.FORCE_CONSTANT_YIELD },
]
